import {
  Cairo,
  DM_Sans,
  Geist,
  Geist_Mono,
  IBM_Plex_Sans_Arabic,
  Instrument_Sans,
  Inter,
  Mulish,
  Noto_Sans_Arabic,
  Outfit,
  Tajawal
} from 'next/font/google';

import { cn } from '@/lib/utils';

// Only the default theme's font (safha → Noto Sans Arabic) is preloaded. The
// rest are picker/theme alternatives; preloading all 11 fired one "preloaded but
// not used" console warning per unused file on every page.
const fontSans = Geist({
  subsets: ['latin'],
  preload: false,
  variable: '--font-sans'
});

const fontMono = Geist_Mono({
  subsets: ['latin'],
  preload: false,
  variable: '--font-mono'
});

const fontInstrument = Instrument_Sans({
  subsets: ['latin'],
  preload: false,
  variable: '--font-instrument'
});

const fontMullish = Mulish({
  subsets: ['latin'],
  preload: false,
  variable: '--font-mullish'
});

const fontInter = Inter({
  subsets: ['latin'],
  preload: false,
  variable: '--font-inter'
});

const fontDMSans = DM_Sans({
  subsets: ['latin'],
  preload: false,
  variable: '--font-dm-sans'
});

const fontOutfit = Outfit({
  subsets: ['latin'],
  preload: false,
  variable: '--font-outfit'
});

const fontIBMPlexArabic = IBM_Plex_Sans_Arabic({
  subsets: ['arabic'],
  weight: ['400', '500', '600', '700'],
  preload: false,
  variable: '--font-ibm-plex-arabic'
});

const fontCairo = Cairo({
  subsets: ['arabic', 'latin'],
  preload: false,
  variable: '--font-cairo'
});

const fontNotoSansArabic = Noto_Sans_Arabic({
  subsets: ['arabic'],
  variable: '--font-noto-sans-arabic'
});

const fontTajawal = Tajawal({
  subsets: ['arabic'],
  weight: ['400', '500', '700', '800'],
  preload: false,
  variable: '--font-tajawal'
});

export type FontOption = {
  name: string;
  value: string;
  type: 'latin' | 'arabic';
};

export const FONTS: FontOption[] = [
  { name: 'Geist', value: 'var(--font-sans)', type: 'latin' },
  { name: 'Inter', value: 'var(--font-inter)', type: 'latin' },
  { name: 'Mulish', value: 'var(--font-mullish)', type: 'latin' },
  { name: 'DM Sans', value: 'var(--font-dm-sans)', type: 'latin' },
  { name: 'Outfit', value: 'var(--font-outfit)', type: 'latin' },
  { name: 'Instrument Sans', value: 'var(--font-instrument)', type: 'latin' },
  { name: 'Cairo', value: 'var(--font-cairo)', type: 'arabic' },
  { name: 'Tajawal', value: 'var(--font-tajawal)', type: 'arabic' },
  {
    name: 'Noto Sans Arabic',
    value: 'var(--font-noto-sans-arabic)',
    type: 'arabic'
  },
  {
    name: 'IBM Plex Sans Arabic',
    value: 'var(--font-ibm-plex-arabic)',
    type: 'arabic'
  }
];

export const fontVariables = cn(
  fontSans.variable,
  fontMono.variable,
  fontInstrument.variable,
  fontMullish.variable,
  fontInter.variable,
  fontDMSans.variable,
  fontOutfit.variable,
  fontIBMPlexArabic.variable,
  fontCairo.variable,
  fontNotoSansArabic.variable,
  fontTajawal.variable
);
